import {
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from "@certn/cascadia-react";
import {
  Modal,
  ButtonGroup,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { dismissCancelledCase } from "../../utils";

export function DismissCancelModal({
  showCancellationModal,
  setShowCancellationModal,
  caseId,
}: {
  showCancellationModal: boolean;
  setShowCancellationModal: (show: boolean) => void;
  caseId: string;
}) {
  const { t } = useTranslation();

  const handleDismiss = () => {
    if (caseId) {
      dismissCancelledCase(caseId);
    }
    setShowCancellationModal(false);
  };

  return (
    <Modal isOpen={showCancellationModal} testID="cancellation-modal">
      <Dialog>
        {() => (
          <>
            <DialogHeader
              onClose={handleDismiss}
              testID="cancellation-modal-header"
            >
              {t("Your background check was cancelled")}
            </DialogHeader>
            <DialogContent testID="basic-modal-content">
              <Stack gap="space-6">
                <Text style="global/body-primary">
                  {t(
                    "It looks like the company that requested your background check has cancelled it. You don't need to complete anything right now."
                  )}
                </Text>
                <Text style="global/body-primary">
                  {t(
                    "If they need updated information, they may send you another request in the future."
                  )}
                </Text>
              </Stack>
            </DialogContent>
            <DialogFooter testID="cancellation-modal-footer">
              <ButtonGroup>
                <PrimaryButton
                  size="medium"
                  onPress={handleDismiss}
                  testID="cancellation-modal-close-button"
                >
                  {t("Close")}
                </PrimaryButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
